import * as React from "react";
const SvgFiRrCondition = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-condition_svg__a)">
      <path
        fill="#062147"
        d="M21 13h-2.159l-5.01-3.854a3 3 0 0 0-.83-.451V1a1 1 0 1 0-2 0v7.696a3 3 0 0 0-.83.451l-5.012 3.854H3c-1.654 0-3 1.346-3 3v7a1 1 0 1 0 2 0v-7c0-.552.45-1 1-1h2.16l5.01 3.854a2.995 2.995 0 0 0 3.66.001l5.011-3.854h2.16a1 1 0 0 1 1 1v7a1 1 0 1 0 2 0v-7c0-1.654-1.347-3-3-3zm-8.39 4.27a1 1 0 0 1-1.219 0l-4.25-3.269 4.25-3.269a1 1 0 0 1 1.218 0l4.25 3.269-4.25 3.27zm11.097-8.977a.999.999 0 1 1-1.414 1.414L20.5 7.914l-1.793 1.793a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L19.086 6.5l-1.793-1.793a.999.999 0 1 1 1.414-1.414L20.5 5.086l1.793-1.793a.999.999 0 1 1 1.414 1.414L21.914 6.5zM.293 6.909a.999.999 0 1 1 1.414-1.414l1.358 1.358a.501.501 0 0 0 .708 0L6.79 3.797a1.001 1.001 0 0 1 1.424 1.404l-3.02 3.061a2.48 2.48 0 0 1-1.773.737c-.667 0-1.296-.26-1.768-.732z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-condition_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCondition;
